<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showEnquiryDialog" id="new-enquiry-dialog">
      <md-dialog-title>Create a new Enquiry</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createEnquiry)">
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <h6>Traveller</h6>

              <template v-if="!customer">
                <div>
                  <md-radio v-model="enquiry.newCustomer" :value="false"
                    >Existing</md-radio
                  >
                  <md-radio v-model="enquiry.newCustomer" :value="true"
                    >New</md-radio
                  >
                </div>
                <div v-if="!enquiry.newCustomer">
                  <customer-dropdown v-model="enquiry.user_id" />
                </div>
                <div v-else>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>First Name</label>
                        <md-input
                          v-model="enquiry.customer.first_name"
                          type="text"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>Last Name</label>
                        <md-input
                          v-model="enquiry.customer.last_name"
                          type="text"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>Email Address</label>
                        <md-input
                          v-model="enquiry.customer.email"
                          type="email"
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <p>{{ customer.full_name }}</p>
              </template>
            </div>

            <div class="md-layout-item md-size-50">
              <h6>Adventures</h6>
              <md-field>
                <md-select
                  v-model="enquiry.tours"
                  name="tours"
                  id="tours"
                  multiple
                >
                  <md-option
                    v-for="tour in availableTours"
                    :key="tour.id"
                    :value="tour.id"
                  >
                    {{ tour.title }}
                  </md-option>
                </md-select>
              </md-field>

              <h6>Travel Date</h6>
              <date-picker
                prefix-class="xmx"
                v-model="enquiry.travel_date"
                valueType="format"
                type="month"
                placeholder="Travel Date"
              ></date-picker>

              <h6>Follow Up Date</h6>
              <date-picker
                prefix-class="xmx"
                v-model="enquiry.follow_up"
                valueType="format"
                type="date"
                placeholder="Select Follow-up Date"
              ></date-picker>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense"
              >Create</md-button
            >
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import tourApi from "@/services/api/tour";
import moment from "moment";
import enquiryApi from "@/services/api/enquiry";

import CustomerDropdown from "@/components/Handi/Users/CustomerDropdown.vue";

export default {
  name: "EnquiryCreateDialog",

  props: {
    enquiryDialog: Boolean,
    customer: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      enquiry: {
        newCustomer: false,
        heat: 3,
        value: 0.0,
        follow_up: moment().format("YYYY-MM-D"),
        travel_date: null,
        user_id: null,
        customer: {
          first_name: null,
          last_name: null,
          email: null
        },
        tours: [],
        manager_id: null
      },
      availableTours: []
    };
  },

  computed: {
    showEnquiryDialog: {
      get() {
        return this.enquiryDialog;
      },
      set() {
        this.cancel();
      }
    },

    isNewCustomer() {
      return this.enquiry.newCustomer;
    }
  },

  components: {
    CustomerDropdown
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    createEnquiry() {
      if (this.customer) {
        this.enquiry.user_id = this.customer.id;
      }

      enquiryApi.createEnquiry(this.enquiry).then(response => {
        this.$emit("enquiry-created", response.data);
      });
    }
  },

  watch: {
    isNewCustomer: function(val) {}
  },

  created() {
    tourApi.getTours().then(response => {
      this.availableTours = response.data.tours;
    });
  }
};
</script>
<style lang="scss" scoped>
h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.md-radio {
  margin-top: 0px;
  margin-bottom: 14px;
}

.xmx-datepicker {
  width: 100%;
  padding-bottom: 12px;
}

.md-dialog .md-dialog-container {
  max-width: 768px;
  min-width: 768px;
  width: 768px !important;
}

#new-enquiry-dialog {
  &::v-deep .md-dialog-container {
    width: 768px;
  }
}
</style>
